export default {
  notifications: {
    title: "Notifications",
    mark_all: "Mark all as read",
    empty: "No notifications"
  }
};